import { ActionListItemDescriptor } from "@shopify/polaris"
import { LockIcon } from "polaris-enhance"

import { Benifit } from "@/models/ICommon"
import stores from "@/stores"

import { PModal } from ".."

// 权限分组定义
export const ESSENTIAL_BENEFITS: Benifit[] = [
  "variant_exchange_setting",
  "refund_to_store_discount",
  "refund_to_store_gift_card",
  "replace_with_the_same_item",
  "return_fee",
  "return_rewards",
  "green_returns",
  "label_qr_code",
  "flexible_label_fee",
  "free_return_service",
  "refund_to_bank_transfer",
  "email_domain",
  "upload_video_proof",
  "blocklist",
  "return_document",
  "multi_language",
  "email_notification",
  "work_flow_specific",
] as const

export const PROFESSIONAL_BENEFITS: Benifit[] = [
  "remove_branding",
  "pp_tracking_conn",
  "work_flow",
  "exchange_for_different_items",
  "refund_via_wise",
  "refund_to_store_credit",
  "connect_own_carriers",
  "returns_data_export",
] as const

export const ENTERPRISE_BENEFITS: Benifit[] = ["webhook"] as const

export const ALL_BENEFITS = [
  ESSENTIAL_BENEFITS,
  PROFESSIONAL_BENEFITS,
  ENTERPRISE_BENEFITS,
] as const

export function getBenefitInfo(benefits: Benifit) {
  const hasBenefits =
    stores.CommonStore.subscribeBenefitList?.[benefits] ?? true

  const getKind = () => {
    const findIndex = ALL_BENEFITS.findIndex((item) => item.includes(benefits))
    if (findIndex !== -1) return findIndex + 2
    return stores.UserInfoStore.data.package_kind
  }

  return {
    hasBenefits,
    kind: getKind(),
  }
}

export function withBenefitAction(
  action: ActionListItemDescriptor,
  benefits: Benifit,
) {
  const { hasBenefits } = getBenefitInfo(benefits)
  if (!hasBenefits) {
    return {
      ...action,
      id: "with-benefit-lock-action",
      icon: LockIcon,
      onAction() {
        PModal.showUpgradeModalByBenefits({ benefits })
      },
    } as ActionListItemDescriptor
  }
  return action
}
